<template>
  <div class="permission-form-grid pl-1 pr-1">
    <b-row class="align-items-center no-gutters">
      <b-col
        cols="4"
        sm="3"
      >
        <div class="permission-label">
          {{ $t('all') }}
        </div>
      </b-col>
      <b-col
        cols="8"
        sm="7"
      >
        <div
          class="inlineSpace"
        >
          <b-form-checkbox
            v-model="master"
            :checked="master"
            name="check-button"
            switch
            inline
          />
        </div>
      </b-col>
    </b-row>
    <template v-for="(v,k) in defaultAbility">
      <b-row
        :key="k"
        class="align-items-center mt-50 mb-50 no-gutters"
      >
        <b-col
          cols="4"
          sm="3"
        >
          <div class="permission-label">
            {{ $t(k) }}
          </div>
        </b-col>
        <b-col
          cols="8"
          sm="9"
        >
          <div
            class="permission-options"
          >
            <b-form-radio
              v-model="v.value"
              :disabled="master"
              :name="k"
              class="custom-control-secondary"
              value="0"
              :style="{'pointer-events': master ? 'none' : 'unset' }"
            >
              {{ $t('off') }}
            </b-form-radio>
            <b-form-radio
              v-model="v.value"
              :disabled="!v.haveView || master"
              :name="k"
              class="custom-control-primary"
              value="1"
              :style="{'pointer-events': master ? 'none' : 'unset' }"
            >
              {{ $t('view') }}
            </b-form-radio>
            <b-form-radio
              v-model="v.value"
              :disabled="!v.haveEdit || master"
              :name="k"
              class="custom-control-success"
              value="2"
              :style="{'pointer-events': !v.haveEdit || master ? 'none' : 'unset' }"
            >
              {{ $t('edit') }}
            </b-form-radio>
          </div>
        </b-col>
      </b-row>
      <!-- sub-permission ของหวย: แสดงเมื่อเลือก "แก้ไข" -->
      <b-row
        v-if="k === 'lotto' && String(v.value) === '2' && !master"
        :key="k + '-scopes'"
        class="align-items-center mb-50 no-gutters lotto-scopes-row"
      >
        <b-col
          cols="4"
          sm="3"
        />
        <b-col
          cols="8"
          sm="9"
          class="lotto-scopes-col"
        >
          <div class="lotto-scopes">
            <b-form-checkbox
              v-for="opt in lottoScopeOptions"
              :key="opt.key"
              v-model="lottoScopes[opt.key]"
              :disabled="!v.haveEdit || master"
              class="custom-control-success"
            >
              {{ $t(opt.label) }}
            </b-form-checkbox>
          </div>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormRadio, BFormCheckbox,
} from 'bootstrap-vue'

const LOTTO_SCOPE_KEYS = ['info', 'round', 'limit', 'rate']

export default {
  components: {
    BRow,
    BCol,
    BFormRadio,
    BFormCheckbox,
  },
  props: {
    ability: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      master: false,
      defaultAbility: {
        dashboard: {
          haveEdit: false,
          haveView: true,
          value: 0,
        },
        summary: {
          haveView: true,
          haveEdit: false,
          value: 0,
        },
        member: {
          haveView: true,
          haveEdit: true,
          value: 0,
        },
        agent: {
          haveView: true,
          haveEdit: true,
          value: 0,
        },
        invoice: {
          haveView: true,
          haveEdit: true,
          value: 0,
        },
        report: {
          haveView: true,
          haveEdit: false,
          value: 0,
        },
        lotto: {
          haveView: true,
          haveEdit: true,
          value: 0,
        },
        api: {
          haveView: true,
          haveEdit: true,
          value: 0,
        },
      },
      actionMap: {
        none: 0,
        read: 1,
        update: 2,
      },
      actionMapReverse: {
        0: 'none',
        1: 'read',
        2: 'update',
      },
      // sub-permission ของหวย — แต่ละ key ใต้ "lotto: แก้ไข"
      lottoScopes: {
        info: false,
        round: false,
        limit: false,
        rate: false,
      },
      lottoScopeOptions: [
        { key: 'info', label: 'แก้ไขข้อมูลหวย' },
        { key: 'round', label: 'จัดการรอบหวย' },
        { key: 'limit', label: 'อั้นหวย' },
        { key: 'rate', label: 'อัตราจ่าย' },
      ],
    }
  },
  watch: {
    // เมื่อกดจาก "ปิด/ดู" → "แก้ไข" ครั้งแรก และยังไม่มี scope ใดติ๊ก
    // ให้ default เปิดทั้ง 4 scope เพื่อให้เลือกสิทธิย่อยได้ครบถ้วน
    'defaultAbility.lotto.value': function onLottoValueChange(newVal) {
      if (String(newVal) === '2'
        && !this.lottoScopes.info
        && !this.lottoScopes.round
        && !this.lottoScopes.limit
        && !this.lottoScopes.rate) {
        this.lottoScopes.info = true
        this.lottoScopes.round = true
        this.lottoScopes.limit = true
        this.lottoScopes.rate = true
      }
    },
  },
  mounted() {
    if (this.$store.state.app.isMaster(this.$store)) {
      this.defaultAbility.system = {
        haveView: true,
        haveEdit: true,
        value: 0,
      }
      this.defaultAbility.loginSecurity = {
        haveView: true,
        haveEdit: true,
        value: 0,
      }
      this.$forceUpdate()
    }

    if (this.ability.length === 1 && this.ability[0].subject === 'all' && this.ability[0].action === 'manage') {
      this.master = true
    } else {
      let hasLottoScope = false
      for (let i = 0; i < this.ability.length; i += 1) {
        const ability = this.ability[i]

        // sub-permission ของหวย — รับทั้ง "update" (รูปแบบใหม่) และ "manage" (legacy)
        if (ability.subject && ability.subject.startsWith('lotto.')) {
          const scopeKey = ability.subject.substring('lotto.'.length)
          if (LOTTO_SCOPE_KEYS.includes(scopeKey)
            && (ability.action === 'update' || ability.action === 'manage')) {
            this.lottoScopes[scopeKey] = true
            hasLottoScope = true
          }
          // eslint-disable-next-line no-continue
          continue
        }

        if (ability.subject === 'lotto') {
          if (ability.action === 'read') {
            this.defaultAbility.lotto.value = this.actionMap.read
          }
          // eslint-disable-next-line no-continue
          continue
        }

        if (ability.subject in this.defaultAbility) {
          this.defaultAbility[ability.subject].value = this.actionMap[ability.action]
        }
      }

      // ถ้ามี sub-permission ใดอย่างน้อย 1 → set lotto radio = "edit"
      if (hasLottoScope) {
        this.defaultAbility.lotto.value = this.actionMap.update
      }
    }

    const myRules = this.$ability.rules
    if (myRules.length > 0 && myRules[0].subject !== 'all' && myRules[0].action !== 'manage') {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const key in this.defaultAbility) {
        const rule = myRules.find(v => v.subject === key)
        if (rule === undefined) {
          delete this.defaultAbility[key]
        } else if (rule.action === 'read') {
          this.defaultAbility[key].haveEdit = false
        }
      }
    }
  },
  methods: {
    isCannotCreateAgent(v) {
      if (v.length === 1 && v[0].subject === 'all' && v[0].action === 'manage') {
        const { rules } = this.$ability
        return !(rules.length === 2 && rules[0].subject === 'all' && rules[0].action === 'manage')
      }
      return false
    },
    buildPermission(v) {
      if (this.isCannotCreateAgent(v)) {
        return this.getAll()
      }
      return v
    },
    getAll() {
      const abilities = [
        { action: 'update', subject: 'dashboard' },
        { action: 'update', subject: 'summary' },
        { action: 'update', subject: 'member' },
        { action: 'update', subject: 'agent' },
        { action: 'update', subject: 'invoice' },
        { action: 'update', subject: 'report' },
        { action: 'read', subject: 'lotto' },
        { action: 'update', subject: 'api' },
      ]
      if (this.defaultAbility.loginSecurity) {
        abilities.push({ action: 'update', subject: 'loginSecurity' })
      }
      return abilities
    },
    onSubmit() {
      if (this.master) {
        this.$emit('onSubmit', [{
          action: 'manage',
          subject: 'all',
        }])
        return
      }

      const ability = []
      Object.entries(this.defaultAbility).forEach(([k, v]) => {
        const value = v.value * 1
        if (value === 0) return

        if (k === 'lotto') {
          // value=1 (view): emit lotto:read เฉยๆ
          // value=2 (edit): emit lotto:read + sub-permission ที่ติ๊กไว้
          ability.push({ subject: 'lotto', action: 'read' })
          if (value === 2) {
            LOTTO_SCOPE_KEYS.forEach(scope => {
              if (this.lottoScopes[scope]) {
                ability.push({ subject: `lotto.${scope}`, action: 'update' })
              }
            })
          }
          return
        }

        ability.push({
          subject: k,
          action: this.actionMapReverse[value],
        })
      })
      this.$emit('onSubmit', ability)
    },
  },
}
</script>

<style lang="scss" scoped>
.permission-label {
  color: #6e666d;
  font-weight: 600;
  line-height: 1.25;
}

.inlineSpace {
  display: flex;
  flex-wrap: wrap;
  text-align: end;
  justify-content: flex-start;
  align-items: center;

  & > * {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    margin-left: 1.5rem;
  }
}

.permission-options {
  display: grid;
  grid-template-columns: repeat(3, minmax(4.5rem, max-content));
  column-gap: 1.15rem;
  max-width: max-content;
  align-items: center;

  & > * {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    margin-left: 0;
  }
}

.lotto-scopes-row {
  margin-top: 0.2rem;
  margin-bottom: 0.85rem;
}

.lotto-scopes-col {
  padding-left: 1.5rem;
  border-left: 2px solid #ebe9f1;
}

.lotto-scopes {
  display: grid;
  grid-template-columns: repeat(2, minmax(8.5rem, 1fr));
  max-width: 24rem;
  column-gap: 2rem;
  row-gap: 0.75rem;
  align-items: center;
  font-size: 0.9em;

  & > * {
    margin: 0;
  }
}

@media (max-width: 576px) {
  .permission-options {
    grid-template-columns: repeat(3, minmax(3.4rem, max-content));
    column-gap: 0.35rem;
  }

  .inlineSpace {
    & > * {
      margin-left: 0.35rem;
    }
  }

  .lotto-scopes-col {
    padding-left: 0.85rem;
  }

  .lotto-scopes {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 400px) {
  .permission-form-grid {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .inlineSpace {
    & > * {
      margin-left: 0.5rem;
    }
  }
}

</style>
